import { render, staticRenderFns } from "./ApplicantIBANData.vue?vue&type=template&id=5e261f67&"
import script from "./ApplicantIBANData.vue?vue&type=script&lang=js&"
export * from "./ApplicantIBANData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports